/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-19 23:31:31
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-21 23:27:52
 * @FilePath: /mooctest.com/src/api/task.js
 */
// 任务相关api
import request from "../utils/request";
import { t } from "../i18n/i18n";
// 获取任务列表（慢）
export function taskListGet(queryBy, keyword, activePage, type, value) {
  return request({
    url: "/task/list",
    method: "GET",
    params: {
      queryBy,
      keyword,
      activePage,
      type,
      value,
    },
  });
}

// 获取任务详情
export function taskDetailGet(tid) {
  return request({
    url: `/task/${tid}`,
    method: "GET",
  });
}

// 获取paper试卷详情
export function paperDetailGet(examId, paperId) {
  return request({
    url: `/paper/${paperId}`,
    method: "GET",
    params: {
      examId,
    },
  });
}

// 获取成绩详情
export function scoreGet(examId) {
  return request({
    url: "/score",
    method: "GET",
    params: {
      examId,
    },
  });
}

// 上传答题附件
export function uploadAnnex(examId, caseId, fd) {
  return request({
    url: `/upload_answer_annex/${examId}/${caseId}`,
    method: "POST",
    data: fd,
    otherOptions: {
      showLoading: true,
      loadingSetting: {
        text: t("common.submitting"),
      },
    },
  });
}

// 上传答案
export function uploadAnswer(examId, caseId, fd) {
  return request({
    url: `/upload_answer/${examId}/${caseId}`,
    method: "POST",
    data: fd,
    otherOptions: {
      showLoading: true,
      loadingSetting: {
        text: t("common.submitting"),
      },
    },
  });
}

// // 上传答案物联网
// export function uploadAnswerWuLian(examId, caseId, fd) {
//   return request({
//     url: `/upload_answer_car/${examId}/${caseId}`,
//     method: "POST",
//     data: fd,
//   });
// }

// 获取文件上传url
export function getUploadUrl(caseId, workerId, examId, type, fileName) {
  return request({
    url: "/uploadAnswersSig",
    method: "GET",
    params: {
      caseID: caseId,
      workerID: workerId,
      examID: examId,
      type,
      filename: fileName,
    },
    otherOptions: {
      showLoading: true,
      loadingSetting: {
        text: t("common.submitting"),
      },
    },
  });
}
